<template lang="pug">
base-dialog(
  :value="value",
  @input="$emit('input', $event)",
  titulo="Forçar Envio de Dados",
  :max-width="maxWidth",
  persistent,
  :mostrar-fechar="false",
  texto-confirmar="Enviar",
  :carregando="carregando",
  :confirmar-desabilitado="bloqueado",
  @confirmar="$emit('confirmar')"
)
  .mb-3.dialog-texto {{ textoDescricao }}

  v-card.pa-2(outlined, elevation="0")
    .text-body-2.font-weight-bold Cliente:
    .font-weight-regular {{ cliente ? cliente.nome : "—" }}

    template(v-if="modulo")
      .text-body-2.font-weight-bold.pt-2 Módulo:
      .font-weight-regular {{ modulo }}

    .text-body-2.font-weight-bold.pt-2 Versão da base:
    .font-weight-regular {{ versaoBase || "—" }}

  .forcar-envio-aviso-versao.mt-2.pa-3(v-if="bloqueado")
    .d-flex.align-center.gap-2
      v-icon(small, color="warning") mdi-alert-circle
      .body-2
        | {{ textoAvisoPrefixo }}
        strong {{ versaoMinima }}
        | {{ textoAvisoSufixo }}

  .mt-3.font-weight-bold Deseja continuar?
</template>

<script>
import BaseDialog from "./BaseDialog";

export default {
  name: "ForcarEnvioDialog",

  components: {
    BaseDialog
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    cliente: {
      type: Object,
      default: null
    },
    modulo: {
      type: String,
      default: ""
    },
    versaoBase: {
      type: String,
      default: ""
    },
    versaoMinima: {
      type: String,
      default: ""
    },
    bloqueado: {
      type: Boolean,
      default: false
    },
    carregando: {
      type: Boolean,
      default: false
    },
    textoDescricao: {
      type: String,
      default: "Encaminhar o comando de atualização para o cliente selecionado."
    },
    textoAvisoPrefixo: {
      type: String,
      default: "A versão da base do cliente é inferior a "
    },
    textoAvisoSufixo: {
      type: String,
      default: ". Atualize a base antes de forçar o envio para garantir a compatibilidade."
    },
    maxWidth: {
      type: [String, Number],
      default: 600
    }
  }
};
</script>

<style scoped>
.dialog-texto {
  font-size: 13px;
  color: #2c3e50;
  line-height: 1.5;
}

.gap-2 {
  gap: 8px;
}

.forcar-envio-aviso-versao {
  background-color: #fff4e5;
  border: 1px solid #ffb74d;
  border-left: 4px solid #fb8c00;
  border-radius: 4px;
  color: #5d4037;
  font-size: 13px;
  line-height: 1.4;
}

.forcar-envio-aviso-versao strong {
  color: #e65100;
  font-weight: 700;
}
</style>
